import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runCounting(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_counting`)
}

export function getKeywordOccurrences(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/keyword_occurrences`)
}

export function handleOverOptimization(pageId, decisions) {
  return axios.post(`/ajax/website_pages/${pageId}/handle_over_optimization`, { decisions })
}
